import React from 'react';
import './VideoPlay.css';

const VideoPlay = ({ videoUrl, onClose }) => {
  return (
    <div className="video-modal-overlay"  onClick={onClose}>
      <div className="video-modal-content">
        <button className="video-close-button">
          &times;
        </button>
        <div className="video-responsive">
          <iframe
            src={videoUrl.replace("watch?v=", "embed/")}
            title="YouTube video player"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default VideoPlay;
